var exports = {
  "C1": "Indicator__xJQ51l",
  "Y9": "Header__d-vh5D",
  "Pd": "SummaryLine__iFS_1_",
  "BD": "Summary__a77yJy",
  "UM": "Author__FrzPSK",
  "Dc": "Timestamp__bpYtCq",
};

module.exports = exports;
